<template>
  <section class="mb-4 pt-3">
    <div class="container sm-px-0">
      <div class="row">
        <div class="col-xl-3">
          <div
              class="aiz-filter-sidebar collapse-sidebar-wrap sidebar-xl sidebar-right z-1035"
              :class="{ active: sidebarActive }"
          >
            <div
                class="overlay overlay-fixed dark c-pointer"
                data-same=".filter-sidebar-thumb"
                data-target=".aiz-filter-sidebar"
                data-toggle="class-toggle"
            ></div>
            <div class="collapse-sidebar c-scrollbar-light text-left">
              <div
                  class="d-flex d-xl-none justify-content-between align-items-center pl-3 border-bottom"
              >
                <h3 class="h6 mb-0 fw-600">{{ $t("筛选") }}</h3>
                <button
                    class="btn btn-sm p-2 filter-sidebar-thumb"
                    data-target=".aiz-filter-sidebar"
                    data-toggle="class-toggle"
                    type="button"
                >
                  <i class="las la-times la-2x"></i>
                </button>
              </div>
              <div class="bg-white shadow-sm rounded mb-3">
                <div class="fs-15 fw-600 p-3 border-bottom">
                  {{ $t("类别") }}
                </div>
                <div class="p-3">
                  <ul v-if="goodsCateName" class="list-unstyled">
                    <li class="mb-2">
                      <router-link
                          class="text-reset fs-14 fw-600"
                          to="/categories"
                      >
                        <i class="las la-angle-left"></i>
                        {{ $t("所有类别") }}
                      </router-link>
                    </li>
                    <li class="mb-2">
                      <a class="text-reset fs-14 fw-600">
                        <i class="las la-angle-left"></i>
                        {{ $t(goodsCateName) }}
                      </a>
                    </li>
                  </ul>
                  <ul v-else-if="goodsBrandName" class="list-unstyled">
                    <li class="mb-2">
                      <router-link class="text-reset fs-14 fw-600" to="/brands">
                        <i class="las la-angle-left"></i>
                        {{ $t("所有品牌") }}
                      </router-link>
                    </li>
                    <li class="mb-2">
                      <a class="text-reset fs-14 fw-600">
                        <i class="las la-angle-left"></i>
                        {{ $t(goodsBrandName) }}
                      </a>
                    </li>
                  </ul>
                  <ul v-else-if="searchText" class="list-unstyled">
                    <li class="mb-2">
                      <router-link class="text-reset fs-14 fw-600" to="#">
                        <i class="las la-angle-left"></i>
                        {{ $t("搜索结果") }} "{{ searchText }}"
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="bg-white shadow-sm rounded mb-3">
                <div class="fs-15 fw-600 p-3 border-bottom">
                  {{ $t("价格范围") }}
                </div>
                <div class="p-3">
                  <el-slider
                      v-model="priceRange"
                      range
                      :max="parseInt(paramMapAll['SHOP_GOODS_BUYER_PRICE_FILTER_MAX']||100000)"
                      @change="onSliderChange"
                  />
                  <div class="row mt-2">
                    <div class="col-6">
                      <span
                          class="range-slider-value value-low fs-14 fw-600 opacity-70"
                          data-range-value-low="2437.96"
                          id="input-slider-range-value-low"
                      >{{ priceRange[0] }}</span
                      >
                    </div>
                    <div class="col-6 text-right">
                      <span
                          class="range-slider-value value-high fs-14 fw-600 opacity-70"
                          data-range-value-high="6635.00"
                          id="input-slider-range-value-high"
                      >{{ priceRange[1] }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9">
          <ul class="breadcrumb bg-transparent p-0">
            <li class="breadcrumb-item opacity-50">
              <router-link class="text-reset" to="/"
              >{{ $t("首页") }}
              </router-link>
            </li>
            <li class="breadcrumb-item opacity-50">
              <router-link class="text-reset" to="/categories"
              >{{ $t("所有类别") }}
              </router-link>
            </li>
            <li class="text-dark fw-600 breadcrumb-item">
              <a class="text-reset">{{ $t(goodsCateName) }}</a>
            </li>
          </ul>

          <div class="text-left">
            <div class="row gutters-5 flex-wrap align-items-center">
              <div class="col-lg col-10">
                <h1 class="h6 fw-600 text-body">
                  {{ $t(goodsCateName) }}
                </h1>
                <input name="keyword" type="hidden" value=""/>
              </div>
              <div class="col-2 col-lg-auto d-xl-none mb-lg-3 text-right">
                <button
                    class="btn btn-icon p-0"
                    data-target=".aiz-filter-sidebar"
                    data-toggle="class-toggle"
                    type="button"
                    @click="sidebarActive = !sidebarActive"
                >
                  <i class="la la-filter la-2x"></i>
                </button>
              </div>
              <!--                todo 添加品牌概念-->
              <div class="col-lg-auto mb-3">
                <label class="mb-0 opacity-50">{{ $t("排序方式") }}</label>
                <div
                    class="dropdown bootstrap-select form-control form-control-sm aiz-"
                >
                  <button
                      class="btn dropdown-toggle btn-light"
                      role="combobox"
                      title="Newest"
                      type="button"
                      @click="toggleSortSelect"
                  >
                    <div class="filter-option">
                      <div class="filter-option-inner">
                        <div class="filter-option-inner-inner">
                          {{ $t(selectedSortOption.name) }}
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                      :class="{ show: showSortSelect }"
                      class="dropdown-menu"
                      style="
                      overflow: hidden;
                      position: absolute;
                      transform: translate3d(0px, 39px, 0px);
                      top: 0;
                      left: 0;
                      will-change: transform;
                    "
                      x-placement="bottom-start"
                  >
                    <div
                        id="bs-select-2"
                        aria-activedescendant="bs-select-2-0"
                        class="inner show"
                        role="listbox"
                        style="overflow-y: auto"
                        tabindex="-1"
                    >
                      <ul
                          class="dropdown-menu inner show"
                          role="presentation"
                          style="margin-top: 0; margin-bottom: 0; position: static"
                      >
                        <li
                            v-for="option in sortOptions"
                            :key="option.id"
                            :class="{
                            selected: option.id === selectedSortOption.id,
                            active: option.id === selectedSortOption.id
                          }"
                            @click="selectSortOption(option)"
                        >
                          <a
                              :class="{
                              selected: option.id === selectedSortOption.id,
                              active: option.id === selectedSortOption.id
                            }"
                              class="dropdown-item"
                          ><span class="text">{{ $t(option.name) }}</span></a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <input name="min_price" type="hidden" value=""/>
          <input name="max_price" type="hidden" value=""/>
          <van-empty
              v-if="!goodsList || goodsList.length === 0"
              :description="$t('没有找到符合条件的商品')"
          />
          <div
              v-else
              class="row gutters-5 row-cols-xxl-4 row-cols-xl-3 row-cols-lg-4 row-cols-md-3 row-cols-2"
          >
            <div
                v-for="goods in goodsList"
                :key="`${goods.shopId}_${goods.id}`"
                class="col"
            >
              <ProductCard :item="goods"/>
            </div>
          </div>
          <PaginationComp
              :cur-page="curPage"
              :total-page="totalPage"
              @goto="goToPage"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ProductCard from "@/components/ProductCard.vue";
import PaginationComp from "@/components/PaginationComp.vue";

export default {
  name: "productList",
  components: {PaginationComp, ProductCard},
  data() {
    const sortOptions = [
      {
        id: 1,
        name: "最新",
        orders: [{column: "`storeGoods.createTime`", asc: false}]
      },
      {
        id: 2,
        name: "最旧",
        orders: [{column: "`storeGoods.createTime`", asc: true}]
      },
      {
        id: 3,
        name: "价格从低到高",
        orders: [{column: "`storeGoods.price`", asc: true}]
      },
      {
        id: 4,
        name: "价格从高到低",
        orders: [{column: "`storeGoods.price`", asc: false}]
      }
    ];
    return {
      totalPage: 0,
      curPage: 0,
      goodsList: [],

      goodsCateName: "",
      goodsCateCode: null,
      goodsBrandName: "",
      goodsBrandCode: null,
      searchText: "",

      sortOption: "",
      showSortSelect: false,
      sortOptions,
      selectedSortOptionId: 1,
      randomMulti: parseInt(Math.random() * new Date().getTime()),

      priceRange: [0, 0],
      sidebarActive: false,
      paramsMore: {},
    };
  },
  computed: {
    selectedSortOption() {
      return this.sortOptions.find(
          option => option.id === this.selectedSortOptionId
      );
    }
  },
  methods: {
    async pageGoods() {
      const pageSize = 20;
      let params = {
        curPage: this.curPage,
        pageSize,
        goodsCateCode: this.goodsCateCode,
        goodsBrandCode: this.goodsBrandCode,
        randomMulti: this.randomMulti,
        searchText: this.searchText,
        orders: this.selectedSortOption.orders,
        priceMin: this.priceRange[0],
        ...this.paramsMore
      }
      const priceMax = this.priceRange[1]
      if (priceMax > 0) {
        params.priceMax = priceMax
      }
      const res = await this.$get("/goods/page", {
        params: params
      });
      const page = res.data;
      this.goodsList = page.records || [];
      this.totalPage = Math.ceil(parseInt(page.total) / pageSize);
      window.scrollTo(0, 0);
    },
    goToPage(page) {
      console.log("goToPage", page);
      if (typeof page !== "number" || page < 1 || page > this.totalPage) return;
      this.curPage = page;
      this.pageGoods();
    },
    closeSelect() {
      this.showSortSelect = false;
    },
    toggleSortSelect() {
      this.showSortSelect = !this.showSortSelect;
    },
    selectSortOption(option) {
      this.selectedSortOptionId = option.id;
      this.pageGoods();
    },
    refresh() {
      this.goodsCateName = decodeURIComponent(this.$route.query.cateName || "");
      this.goodsCateCode = this.$route.query.cateCode;
      this.goodsBrandName = this.$route.query.brandName;
      this.goodsBrandCode = this.$route.query.brandCode;
      this.searchText = this.$route.query.keyword;
      this.curPage = 1;
      this.pageGoods();
    },
    onSliderChange() {
      this.sidebarActive = false;
      this.refresh();
    }
  },
  watch: {
    $route: {
      handler() {
        this.refresh();
      }
    }
  },
  created() {
    let {buyDiscountWhere} = this.$route.query
    if (buyDiscountWhere) {
      this.paramsMore.buyDiscountWhere = decodeURIComponent(buyDiscountWhere)
    }
    this.refresh();
    // this.priceRange[1] = parseInt(this.paramMapAll['SHOP_GOODS_BUYER_PRICE_FILTER_MAX']||10000)
  },
  mounted() {
    document.addEventListener("click", this.closeSelect, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeSelect);
  }
};
</script>
